import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      paddingTop: 16,
      paddingBottom: 35,
      [theme.breakpoints.up("mobile")]: {
        paddingTop: 40,
      },
    },
    title: {
      textAlign: "center",
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(19),
      lineHeight: theme.typography.pxToRem(24),
      marginBottom: 8,
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.pxToRem(28),
        lineHeight: theme.typography.pxToRem(34),
        textAlign: "left",
        marginBottom: 28,
      },
    },
    grid: {
      marginBottom: 40,
    },
  }),
  { name: "FeaturedCategories" },
);
